import { controls,grouped } from "../controls";
const slbc_acp_npa_outstandings = {
label: "Slbc Acp Npa Outstandings",
pageLabel: "Slbc Acp Npa Outstandings",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Slbc Block",star:true}),
...controls.oc({ tab: "general", c: "SLBCBlock", placeHolder: "Slbc Block Code", name: "slbc_block_code",isRequired:true,fastpath: "slbc_blocks",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "slbc_block_display"}),
...controls.displayText({ tab: "general", label: "Farm Credit No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "farm_credit_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Farm Credit Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "farm_credit_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "total crop loan No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "out_of_farm_credit_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "total crop loan amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "out_of_farm_credit_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "total investment credit loan No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "out_of_farm_credit_no_1",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "total investment credit loan Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "out_of_farm_credit_amt_1",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "total allied activity loan No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "out_of_farm_credit_no_2",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "total allied activity loan Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "out_of_farm_credit_amt_2",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Agri Infra No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "agri_infra_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Agri Infra Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "agri_infra_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Ancillary Activities No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "ancillary_activities_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Ancillary Activities Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "ancillary_activities_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Micro Ent No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "micro_ent_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Micro Ent Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "micro_ent_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Small Ent No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "small_ent_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Small Ent Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "small_ent_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Medium Ent No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "medium_ent_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Medium Ent Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "medium_ent_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Other Msmes No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "other_msmes_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Other Msmes Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "other_msmes_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Export Cr No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "export_cr_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Export Cr Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "export_cr_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Education Ps No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "education_ps_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Education Ps Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "education_ps_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Housing Ps No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "housing_ps_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Housing Ps Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "housing_ps_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Social Infr No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "social_infr_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Social Infr Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "social_infr_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Renewable Energy No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "renewable_energy_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Renewable Energy Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "renewable_energy_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Other Ps No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "other_ps_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Other Ps Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "other_ps_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Loans To Weaker Ps No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "loans_to_weaker_ps_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Loans To Weaker Ps No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "loans_to_weaker_ps_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Agri Nps No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "agri_nps_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Agri Nps Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "agri_nps_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Education Nps No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "education_nps_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Education Nps Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "education_nps_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Housing Nps No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "housing_nps_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Housing Nps Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "housing_nps_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Personal Loans Nps No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "personal_loans_nps_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Personal Loans Nps Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "personal_loans_nps_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Other Nps No",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "other_nps_no",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Other Nps Amt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "other_nps_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
]
,history:{
perPage: 10,
reportHeader: "Slbc Acp Npa Outstandings",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Farm Credit No",accessor: "farm_credit_no",},
{Header: "Farm Credit Amt",accessor: "farm_credit_amt",},
{Header: "total crop loan No",accessor: "out_of_farm_credit_no",},
{Header: "total crop loan amount",accessor: "out_of_farm_credit_amt",},
{Header: "total investment credit loan No",accessor: "out_of_farm_credit_no_1",},
{Header: "total investment credit loan Amount",accessor: "out_of_farm_credit_amt_1",},
{Header: "total allied activity loan No",accessor: "out_of_farm_credit_no_2",},
{Header: "total allied activity loan Amount",accessor: "out_of_farm_credit_amt_2",},
{Header: "Agri Infra No",accessor: "agri_infra_no",},
{Header: "Agri Infra Amt",accessor: "agri_infra_amt",},
{Header: "Ancillary Activities No",accessor: "ancillary_activities_no",},
{Header: "Ancillary Activities Amt",accessor: "ancillary_activities_amt",},
{Header: "Micro Ent No",accessor: "micro_ent_no",},
{Header: "Micro Ent Amt",accessor: "micro_ent_amt",},
{Header: "Small Ent No",accessor: "small_ent_no",},
{Header: "Small Ent Amt",accessor: "small_ent_amt",},
{Header: "Medium Ent No",accessor: "medium_ent_no",},
{Header: "Medium Ent Amt",accessor: "medium_ent_amt",},
{Header: "Other Msmes No",accessor: "other_msmes_no",},
{Header: "Other Msmes Amt",accessor: "other_msmes_amt",},
{Header: "Export Cr No",accessor: "export_cr_no",},
{Header: "Export Cr Amt",accessor: "export_cr_amt",},
{Header: "Education Ps No",accessor: "education_ps_no",},
{Header: "Education Ps Amt",accessor: "education_ps_amt",},
{Header: "Housing Ps No",accessor: "housing_ps_no",},
{Header: "Housing Ps Amt",accessor: "housing_ps_amt",},
{Header: "Social Infr No",accessor: "social_infr_no",},
{Header: "Social Infr Amt",accessor: "social_infr_amt",},
{Header: "Renewable Energy No",accessor: "renewable_energy_no",},
{Header: "Renewable Energy Amt",accessor: "renewable_energy_amt",},
{Header: "Other Ps No",accessor: "other_ps_no",},
{Header: "Other Ps Amt",accessor: "other_ps_amt",},
{Header: "Loans To Weaker Ps No",accessor: "loans_to_weaker_ps_no",},
{Header: "Loans To Weaker Ps No",accessor: "loans_to_weaker_ps_no",},
{Header: "Agri Nps No",accessor: "agri_nps_no",},
{Header: "Agri Nps Amt",accessor: "agri_nps_amt",},
{Header: "Education Nps No",accessor: "education_nps_no",},
{Header: "Education Nps Amt",accessor: "education_nps_amt",},
{Header: "Housing Nps No",accessor: "housing_nps_no",},
{Header: "Housing Nps Amt",accessor: "housing_nps_amt",},
{Header: "Personal Loans Nps No",accessor: "personal_loans_nps_no",},
{Header: "Personal Loans Nps Amt",accessor: "personal_loans_nps_amt",},
{Header: "Other Nps No",accessor: "other_nps_no",},
{Header: "Other Nps Amt",accessor: "other_nps_amt",},
]}};
export default slbc_acp_npa_outstandings;